<template>
  <form @submit.prevent="handleSubmit" class="contact-form">
    <div class="form-field">
      <input
        type="email"
        v-model="formData.email"
        :placeholder="emailPlaceholder"
        required
      />
      <input
        type="text"
        v-model="formData.subject"
        :placeholder="subjectPlaceholder"
        required
      />
    </div>

    <div
      v-for="(field, index) in formFields"
      :key="index"
      class="form-field textarea-field"
    >
      <textarea
        v-model="formData.customFields[field.name]"
        :placeholder="field.name"
        rows="5"
      ></textarea>
      <button type="submit" class="submit-btn">
        {{ submitText }}
      </button>
    </div>

    <p v-if="formSubmitted" class="success-message">
      {{ successMessage }}
    </p>
  </form>
</template>

<script setup>
import axios from 'axios';

const props = defineProps({
  emailPlaceholder: String,
  subjectPlaceholder: String,
  formFields: Array,
  submitText: String,
  successMessage: String,
  toEmail: String,
  ccEmail: String
});

const formData = ref({
  email: '',
  subject: '',
  customFields: {}
});

const formSubmitted = ref(false);

const handleSubmit = async () => {
  const message = Object.entries(formData.value.customFields)
    .map(([key, value]) => `${key}: ${value}`)
    .join('\n');

  const params = {
    name: formData.value.email,
    email: formData.value.email,
    subject: formData.value.subject,
    message: message
  };

  try {
    const queryString = new URLSearchParams(params).toString();
    await axios.get('/api/mailer?' + queryString);
    formSubmitted.value = true;

    setTimeout(() => {
      formSubmitted.value = false;
      formData.value = {
        email: '',
        subject: '',
        customFields: {}
      };
    }, 3000);
  } catch (error) {
    console.error('Form submission failed:', error);
  }
};
</script>

<style lang="scss" scoped>
.contact-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-inline: var(--inline-margin);
}

.form-field {
  display: flex;
  gap: 2rem;

  input, textarea {
    padding: 1rem 2rem;
    border-radius: 2em;
    font-size: var(--text-lg);

    &:focus {
      outline: none;
      border-color: var(--orange);
    }
  }

  textarea {
    resize: vertical;
    padding: 2rem 2rem;
  }

  &.textarea-field {
    position: relative;
  }
}

.submit-btn {
  position: absolute;
  bottom: 2rem;
  right: 2rem;
  padding: 1rem 2rem;
  background: var(--orange);
  color: var(--mahogany);
  border: none;
  border-radius: 50px;
  font-size: var(--text-lg);
  cursor: pointer;
  transition: all 0.2s;
  width: auto;
  min-width: auto;

  &:hover {
    background: #e55535;
    transform: translateY(-1px);
  }
}
</style>
